'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isUnreadable"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HAS_SEEN_UNREADABLE } from '../../constants/newFeatures';
import NewFeatureShepherd from './NewFeatureShepherd';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = key => `RichTextLib.newFeatures.unreadable.${key}`;
export default function UnreadableShepherd(_ref) {
  let {
      children,
      isUnreadable
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const header = /*#__PURE__*/_jsx("h4", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('header')
    })
  });
  const body = /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('body')
  });
  return /*#__PURE__*/_jsx(NewFeatureShepherd, Object.assign({}, props, {
    settingsKey: HAS_SEEN_UNREADABLE,
    placement: "top left",
    width: 350,
    header: header,
    body: body,
    shouldShow: isUnreadable,
    children: children
  }));
}